angular.module('unica_approvation_list.approvation_list_controllers')

.controller('ApprovationListListController',
	function(
		$rootScope, $scope, $state, $stateParams,
		$confirm,
		ApprovationListListService, ApprovationListDeleteService, ApprovationListEditService
	) {

	$scope.event_id = $stateParams.event_id;
	$scope.invitation_list_id = $stateParams.invitation_list_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.approvationLists = [];

	$scope.loadApprovationLists = function() {
		$scope.showLoader();

		ApprovationListListService
			.list( $stateParams.invitation_list_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					$scope.approvationLists = $scope.approvationLists.concat( data );
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadApprovationLists();

	$scope.sendAllApprovationList = function( invitationListId ) {

		$confirm({
			title: 'Sei sicuro di voler inviare tutte le Liste Approvazione?',
			text: 'Confermi invio delle Liste Approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListEditService
				.sendAll( invitationListId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						$scope.approvationLists = data;
						$scope.showSuccessMsg('Lista Approvazione inviata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});

		}, function() {
			// Cancel
		});

	};

	$scope.resetStatusApprovationList = function( approvationListId ) {

		$confirm({
			title: 'Sei sicuro di voler resettare lo status della Lista Approvazione?',
			text: 'Confermi il reset status della Lista Approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListEditService
				.resetStatus( approvationListId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.approvationLists, function(approvationList, key) {
							if ( approvationList.id == approvationListId ) {
								$scope.approvationLists[key].status = 'compile';
							}
						});
						$scope.showSuccessMsg('Lista Approvazione resettato status con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});


		}, function() {
			// Cancel
		});

	};

	$scope.resendApprovationList = function( approvationListId ) {

		$confirm({
			title: 'Lista già inviata! Sei sicuro di voler inviare di nuovo la Lista Approvazione?',
			text: 'Confermi un altro invio della Lista Approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListEditService
				.send( approvationListId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.approvationLists, function(approvationList, key) {
							if ( approvationList.id == approvationListId ) {
								$scope.approvationLists[key].sent_date = 'done';
							}
						});
						$scope.showSuccessMsg('Lista Approvazione inviata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});


		}, function() {
			// Cancel
		});

	};

	$scope.sendApprovationList = function( approvationListId ) {

		$confirm({
			title: 'Sei sicuro di voler inviare la Lista Approvazione?',
			text: 'Confermi invio della Lista Approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListEditService
				.send( approvationListId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.approvationLists, function(approvationList, key) {
							if ( approvationList.id == approvationListId ) {
								$scope.approvationLists[key].sent_date = 'done';
							}
						});
						$scope.showSuccessMsg('Lista Approvazione inviata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});


		}, function() {
			// Cancel
		});

	};

	$scope.deleteApprovationList = function( approvationListId ) {

		$confirm({
			title: 'Sei sicuro di voler eliminare la Lista Approvazione?',
			text: 'Confermi la cancellazione della Lista Approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListDeleteService
				.delete( approvationListId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.approvationLists, function(approvationList, key) {
							if ( approvationList.id == approvationListId ) {
								$scope.approvationLists.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Lista Approvazione eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});

		}, function() {
			// Cancel
		});

	};

});
